defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlayCountdown',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Framework/TimeUtils/Scripts/TimeUtils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'Shared/Framework/Mithril/Scripts/Helpers/Render',
    'Shared/Framework/Mithril/Scripts/Helpers/MithrilRedrawEverySecond'
  ],
  function (m, TimeUtils, Utils, Render, MithrilRedrawEverySecond) {

    // Context:
    var PlayCountdown = function (args) {
      var render = Render();
      var timestamp = args.timestamp;
      var countdownTime = new Date(timestamp);
      var today = TimeUtils.getCurrentDateTime();

      var getTimeRemaining = function () {
        const diffSeconds = Math.floor((countdownTime.getTime() / 1000) - (today.getTime() / 1000));
        var days = Math.floor(diffSeconds / 86400) <= 0 ? 0 : Math.floor(diffSeconds / 86400);
        var hours = Math.floor(diffSeconds / 3600 % 24) <= 0 ? 0 : Math.floor(diffSeconds / 3600) % 24;
        var minutes = Math.floor(diffSeconds % 3600 / 60) <= 0 ? 0 : Math.floor(diffSeconds % 3600 / 60);
        var seconds = Math.floor(diffSeconds % 3600 % 60) <= 0 ? 0 : Math.floor(diffSeconds % 3600 % 60);

        if (diffSeconds < 0) {
          return null;
        }

        var timeLeft = [{
          label: hours === 1 ? 'time' : 'timer',
          value: Utils.leadingZero(hours)
        }, {
          label: 'min.',
          value: Utils.leadingZero(minutes)
        }, {
          label: 'sek.',
          value: Utils.leadingZero(seconds)
        }];

        if (days > 0) {
          timeLeft.unshift({
            label: days === 1 ? 'dag' : 'dage',
            value: Utils.leadingZero(days)
          });
        }

        return m('.countdown-time-segments', timeLeft.map((segment) => {
          return m('.countdown-time-segment', [
            m('span.countdown-time-segment__value', segment.value),
            args.showTimeSegmentLabel ? m('span.countdown-time-segment__label', segment.label) : null
          ]);
        }));
      };

      render.ready.then(function () {
        MithrilRedrawEverySecond.start();
      });

      var countdownContent = function () {
        if (args.includeDays) {
          return getTimeRemaining();
        }

        if (Utils.isSameDay(today, countdownTime)) {
          if (args.countdownDictionary) {
            var container = document.createElement('div');
            m.render(container, getTimeRemaining());
            return m.trust(args.countdownDictionary('CountdownSameDay', { countdown: container.innerHTML }));
          }
          return getTimeRemaining();
        }

        // If the countdown is longer than 24h
        var countdownDay = Utils.parseISO8601(timestamp.toISOString()).dayName;
        if (args.countdownDictionary) {
          return m.trust(args.countdownDictionary('CountdownNotSameDay', { countdown: countdownDay }));
        }
        return countdownDay;
      };
      return m('.countdown-wrapper', { config: render.depend('countdown-wrapper') }, countdownContent());
    };

    // Public functions:
    return PlayCountdown;
  });
